import { Box, Checkbox, Divider, FormControlLabel, Grid, TablePagination } from '@mui/material';
import React, { useEffect, useMemo, useRef } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { permissionObj } from '../../../../Helpers/permission';
import { GetOnBoarding } from '../../../../reduxToolkit/EmployeeOnBoarding/EmployeeOnBoardingApi';
import { useTranslation } from 'react-i18next';
import DeleteModal from '../../../Modals/DeleteModal';
import { DeleteItemsApi } from '../../../../reduxToolkit/Commons/CommonsApi';
import NotInformation from '../../../../components/NotInformation';
import HeadTittle from '../../../../components/HeadTittle';
import { TrashOutlineIcon } from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import DivContainerBody from '../../../../components/DivContainerBody';
import { calculateHeight } from '../../../../Apis/functions';

const OnBoarding = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(12);
    const cardContainerRef = useRef(null);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [selectBordingForDelete, setSelectBordingForDelete] = useState([]);
    const [showOnBoaring, setShowOnBoarding] = useState(false);

    //use Selector hook to get state for redux store
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { getOnBoarding } = useSelector((state) => state.employeeOnBoardingSlice);
    const { deleteItemsApi } = useSelector((state) => state.CommonsSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { t } = useTranslation();

    // only the cards that already have an onboarding can be selected
    const selectableIds = useMemo(
        () => getOnBoarding?.content?.filter((item) => item?.id != null).map((item) => item?.id) ?? [],
        [getOnBoarding?.content],
    );

    // custom Funtion
    const deleteOnBoarding = (deleteItem) => {
        const tableName = 'onboarding';
        const body = deleteItem;
        dispatch(DeleteItemsApi({ tableName, body }));
        setSelectBordingForDelete([]);
        setIsAllChecked(false);
    };

    // this function control select all id or unSelect all
    const handelDeleteAll = (e) => {
        setIsAllChecked(e.target.checked);
        setSelectBordingForDelete(e.target.checked ? selectableIds : []);
    };
    // this function handle only specific id base on selection
    const handleCheckboxChange = (e, data) => {
        const newSelection = e.target.checked
            ? [...selectBordingForDelete, data.id]
            : selectBordingForDelete.filter((id) => id !== data.id);

        setSelectBordingForDelete(newSelection);
        // keep the select all flag in sync when the rows are checked one by one
        setIsAllChecked(newSelection.length > 0 && newSelection.length === selectableIds.length);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };
    useEffect(() => {
        const pagination = {
            order: true,
            page: 0,
            size: rowsPerPage,
            sortBy: 'id',
        };
        dispatch(GetOnBoarding(pagination));
    }, [page, rowsPerPage, deleteItemsApi]);

    useEffect(() => {
        calculateHeight({elementRef: cardContainerRef, undefined, bottom: 90})
    }, []);

    return (
        <>
            <HeadTittle name={'on_boarding'}>
                {(DEV || permission?.includes(permissionObj?.WEB_ONBOARDING_DELETE)) && (
                    <ButtonAction
                        id='btn_ob_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectBordingForDelete?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={()=>{
                            setShowOnBoarding(true);
                        }}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <div className=''>
                    <Box>
                        {(DEV || permission?.includes(permissionObj?.WEB_ONBOARDING_DELETE)) &&
                            selectableIds?.length > 0 && (
                                <FormControlLabel
                                    className='m-left-9'
                                    control={
                                        <Checkbox
                                            label='Label'
                                            checked={isAllChecked}
                                            onChange={handelDeleteAll}
                                            indeterminate={selectBordingForDelete?.length > 0 && !isAllChecked}
                                            size='small'
                                        />
                                    }
                                    label={t('de_/_select_all')}
                                />
                            )}
                    </Box>
                </div>
                <Box className='on_boarding_container p-t-06' ref={cardContainerRef}>
                    {getOnBoarding?.content?.length > 0 ? (
                        <Grid container spacing={2} className='grid-container-cards--onBoarding h-100'>
                            {getOnBoarding?.content?.map((data) => {
                                return (
                                    <Grid
                                        key={data?.id ?? `role-${data?.roleId}`}
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={3}
                                        className={'h-100 overflow-y-auto'}
                                    >
                                        <Box className='on_boarding_container_item h-100'>
                                            <section className='header-cards-onboarding'>
                                                {data?.id != null ? (
                                                    <>
                                                        {(DEV ||
                                                            permission?.includes(permissionObj?.WEB_ONBOARDING_UPDATE) ||
                                                            permission?.includes(permissionObj?.WEB_ONBOARDING_DELETE)) && (
                                                            <section className='section-updateAndCheckbox--OnBoarding'>
                                                                {(DEV || permission?.includes(permissionObj?.WEB_ONBOARDING_UPDATE)) && (
                                                                    <button
                                                                        className='btn'
                                                                        onClick={() =>
                                                                            navigate(
                                                                                `/dashboard/employee/company/onboarding-UE/${data?.id}`,
                                                                            )
                                                                        }
                                                                    >
                                                                        <i
                                                                            className='fa fa-pencil'
                                                                            aria-hidden='true'
                                                                        />
                                                                    </button>
                                                                )}
                                                                {(DEV || permission?.includes(permissionObj?.WEB_ONBOARDING_DELETE)) && (
                                                                    <Checkbox
                                                                        size='small'
                                                                        checked={selectBordingForDelete?.includes(
                                                                            data?.id,
                                                                        )}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange(e, data)
                                                                        }
                                                                    />
                                                                )}
                                                            </section>
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        {(DEV ||
                                                            permission?.includes(
                                                                permissionObj?.WEB_ONBOARDING_CREATE,
                                                            )) && (
                                                            <button
                                                                className='btn'
                                                                onClick={() => {
                                                                    sessionStorage.setItem(
                                                                        'onBoardingRoleId',
                                                                        data?.roleId,
                                                                    );
                                                                    sessionStorage.setItem(
                                                                        'onBoardingRoleName',
                                                                        data?.roleName,
                                                                    );
                                                                    navigate(
                                                                        `/dashboard/employee/company/onboarding-UE/${data?.id}`,
                                                                    );
                                                                }}
                                                            >
                                                                <i className='fa fa-plus' aria-hidden='true' />
                                                            </button>
                                                        )}
                                                    </>
                                                )}
                                                <Box className='on_boarding_container_header'>
                                                    <h4>{t('privilege')}</h4>
                                                    <p>{data?.roleName || '-'} </p>
                                                </Box>
                                            </section>
                                            <Divider className='margin-y-04' />
                                            <Box className='on_boarding_container_content'>
                                                {data?.id != null ? (
                                                    <Box className='p-left-1'>
                                                        <Box className='on_boarding_container_content_item'>
                                                            <h4>{t('manager')}</h4>
                                                            <Box className='list'>
                                                                <Box className='icon'></Box>
                                                                <p>{data?.managerName}</p>
                                                            </Box>
                                                        </Box>
                                                        <Box className='on_boarding_container_content_item'>
                                                            <h4>{t('work_station')}</h4>
                                                            <Box className='list'>
                                                                <Box className='icon'></Box>
                                                                <p>{data?.zoneName}</p>
                                                            </Box>
                                                        </Box>
                                                        <Box className='on_boarding_container_content_item'>
                                                            <h4>{t('things_to_do')}</h4>
                                                            <Box className='list'>
                                                                <Box className='icon'></Box>
                                                                <p>{data?.processNo}</p>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                ) : (
                                                    <NotInformation text={t('no_information')} card={false} />
                                                )}
                                            </Box>
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    ) : (
                        <NotInformation text={t('no_information')} card={true} />
                    )}
                </Box>

                <Box className='center-pagination'>
                    <TablePagination
                        component='div'
                        rowsPerPageOptions={[12, 16, 24, 32]}
                        count={getOnBoarding?.totalElements}
                        page={page}
                        onPageChange={handleChangePage}
                        labelRowsPerPage={t('onboarding_per_page')}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        className='custom-pagination'
                    />
                </Box>
            </DivContainerBody>
            <DeleteModal
                show={showOnBoaring}
                onHide={() => setShowOnBoarding(false)}
                onClickFn={() => deleteOnBoarding(selectBordingForDelete)}
                data={selectBordingForDelete}
                title_modal={'on_boarding'}
                element_modal={'onboarding'}
                isReset={setSelectBordingForDelete}
                isAllReset={setIsAllChecked}
            />
        </>
    );
};

export default OnBoarding;
